import policies from "./policies"
import quotes from "./quotes"

export default {
	...policies,
	...quotes
}
